import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    classificationGroupModule
} from '@/presentation/pages/ai-search/components/classification-group/classification-group.module';
import { keywordGroupModule } from '@/presentation/pages/ai-search/components/keyword-group/keyword-group.module';
import { feedbackRequestModule } from '@analytics/shared/components/feedback/feedback.module';

export const componentModule = new ContainerModule((bind) => {
    classificationGroupModule(bind);
    keywordGroupModule(bind);
    feedbackRequestModule(bind);
});
